<template>
  <!-- 学术研究 -->
  <div class="academicCenter">
    <!-- 头部 -->
    <headerNav
      activeIndex="academicCenter"
      @setBanner="setBanner"
      @getUrl="getUrl"
    ></headerNav>
    <!-- 轮播图 -->
    <bannerNav
      :carousel="info.carousel"
      :Mcarousel="info.Mcarousel"
    ></bannerNav>
    <div class="pc maxWidth" id="mainNav">
      <div style="display: flex">
        <div>
          <div class="selectLeft">
            <el-form ref="form" :model="form" label-width="0">
              <div
                style="display: flex; align-items: center; margin: 10px 0 10px"
              >
                <div style="flex: 1">功效</div>
                <div class="clearBtn" @click="clearBtn(1)">
                  <i class="el-input__icon el-icon-delete"></i> 清空
                </div>
              </div>
              <el-form-item>
                <el-checkbox-group v-model="form.type" @change="changeCheck">
                  <el-checkbox
                    v-for="(item, index) of gxList"
                    :key="index"
                    :label="item.id"
                    name="type"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
              <!-- <div style="display: flex; align-items: center; margin: 30px 0 10px">
                <div style="flex: 1">发布时间</div>
                <div class="clearBtn" @click="clearBtn(2)">
                <i class="el-input__icon el-icon-delete"></i> 清空
                </div>
            </div> -->
              <!-- <el-form-item>
                <el-date-picker
                v-model="times"
                type="daterange"
                style="width: 100%"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                >
                </el-date-picker>
            </el-form-item> -->
            </el-form>
          </div>
          <div class="selectLeft" style="margin-top: 20px">
            <div
              style="
                font-weight: 500;
                color: #293a4c;
                line-height: 28px;
                border-bottom: #e6e6e6 1px solid;
                width: 100%;
                padding: 16px 0;
              "
            >
              论文排行
            </div>
            <div
              v-for="(item, index) of rankList"
              :key="index"
              class="lwRankingNav"
            >
              <div
                class="lwRankIndex"
                :style="
                  index === 0
                    ? 'background:#26B3AE;'
                    : index === 1
                    ? 'background:#26B3AE;opacity: 0.8'
                    : index === 2
                    ? 'background:#26B3AE;opacity: 0.6'
                    : ''
                "
              >
                {{ index + 1 }}
              </div>
              <div class="lwRanking" @click="goLwDetail(item)">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
        <div class="academicList" style="flex: 1">
          <div class="academicList-top">
            <div style="flex: 1">全部结果</div>
            <div>
              <el-input placeholder="请输入内容" v-model="content">
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search"
                  @click="getAcademic"
                  style="cursor: pointer"
                ></i>
              </el-input>
            </div>
          </div>
          <div v-if="companyNewsList.length > 0">
            <div
              class="academicList-main"
              v-for="(item, index) of companyNewsList"
              :key="index"
              @click="goDetail(item)"
            >
              <div style="flex: 1">
                <div class="academicList-main-title">{{ item.title }}</div>
                <div class="academicList-main-content">
                  {{ item.authorName }} | {{ getTypeName(item.efficacyId) }} |
                  {{ item.releaseTime }}
                </div>
              </div>
              <div class="academicList-Btn">
                <a>查看详情</a>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="academicList-main">
              <div style="flex: 1">暂无数据</div>
            </div>
          </div>
          <pager
            :total="total"
            :pageSize="pageSize"
            :pageNum.sync="currentPage1"
            @goPage="goPage()"
          ></pager>
        </div>
      </div>
    </div>

    <div class="mobile">
      <div>
        <div
          style="
            margin: 0 auto 0;
            padding: 0.38rem 0 0.2rem;
            text-align: center;
          "
        >
          <div
            style="
              font-size: 0.34rem;
              line-height: 1.4;
              color: #ddd;
              font-weight: 400;
              font-family: 'Proxima-Bold', sans-serif;
            "
          >
            ACADEMIC RESEARCH
          </div>
          <div
            style="color: #0f3a3c; font-weight: 600; margin-top: -4px"
            class="fzTitle"
          >
            学术研究
          </div>
        </div>
        <div style="padding: 0 0.2rem 0.2rem">
          <el-input placeholder="请输入内容" v-model="content"
              @change="getAcademic">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              style="cursor: pointer"
            ></i>
          </el-input>
        </div>
        <div style="padding: 0 0.2rem 0.26rem">
          <template>
            <div
              v-for="(item, index) of companyNewsList"
              :key="index"
              style="
                border-bottom: 1px solid #e5e5e5;
                padding-bottom: 0.2rem;
                margin-bottom: 0.2rem;
              "
              @click="goDetail(item)"
            >
              <div
                style="
                  font-size: 14px;
                  font-weight: 400;
                  color: #44c48d;
                  line-height: 20px;
                "
              >
                {{ getTypeName(item.efficacyId) }}
              </div>
              <div
                style="
                  font-size: 0.19rem;
                  line-height: 24px;
                  margin-top: 5px;
                  color: #293a4c;
                  font-weight: 500;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                "
              >
                {{ item.title }}
              </div>
              <div
                style="
                  font-size: 0.17rem;
                  line-height: 20px;
                  margin-top: 5px;
                  color: #959597;
                "
              >
                {{ item.authorName }}
              </div>
              <div
                style="
                  margin-top: 5px;
                  display: flex;
                  align-items: center;
                  font-size: 0.17rem;
                  line-height: 20px;
                "
              >
                <div style="flex: 1; color: #959597">
                  发布时间：{{ item.releaseTime }}
                </div>
                <div style="font-size: 14px;color: #44c48d">查看详情</div>
              </div>
            </div>
          </template>
          <div
            v-if="total === companyNewsList.length"
            style="font-size: 0.12rem; text-align: center; color: #666"
          >
            下拉到底部了
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <RightBar></RightBar>
    <footerNav></footerNav>
  </div>
</template>

<script>
import $ from "jquery";
import headerNav from "@/components/headerNav/index";
import bannerNav from "@/components/banner/index";
import footerNav from "@/components/footerNav/index";
import { geteffectList, getacademic, getacademicRanking } from "@/api/academic";

import { updateReadingVolume } from "@/api/common";

export default {
  name: "academicCenter",
  components: { headerNav, footerNav, bannerNav },
  data() {
    return {
      info: {
        carousel: [],
        Mcarousel: "",
      }, //轮播图
      show: false,
      mobile: false,
      navIndex: 1,
      brandProfileNavShow: false,
      top: 100,
      numShow: false,
      currentPage1: 1,
      pageSize: 10,
      type: 1,
      total: 0,
      companyNewsList: [], //公司新闻数据集合
      industryNewsList: [], //行业动态数据集合
      newsDetail: {}, //新闻详情
      // --------------------  new  -------------------
      content: "",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      times: [],
      gxList: [], // 功效分类列表
      rankList: [],
    };
  },
  mounted() {
    this.mobile = this.isMobile();
    if (this.mobile === true) {
      this.pageSize = 100;
    } else {
      window.addEventListener("scroll", this.getScroll);
    }
    if (this.isMobile() === true) {
      this.postMessage(
        "御方汇植物化妆品原料【官网】",
        "新闻中心",
        window.location.href,
        this.getUrlPrefix(this.getBaseInfo().logo)
      );
    }

    this.getEffect();
    this.getRanking();
    if (this.$route.params.id) {
      this.goDetail(this.$route.params.id);
    }
  },
  methods: {
    setBanner(url, mUrl) {
      this.info = {
        carousel: [url],
        Mcarousel: [mUrl],
      };
    },
    getScroll() {
      var aboutUsIndex = document.getElementById("mainNav").offsetTop;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.mobile === false) {
        this.show = aboutUsIndex - 200 < scrollTop;
      }
    },
    goNav(name) {
      var a = document.getElementById("mainNav").offsetTop;
      $("body,html").animate({ scrollTop: a - 200 }, 200);
      if (this.navIndex === name) {
        return;
      }
      this.navIndex = name;
      this.getAcademic();
      if (name === 1) {
        this.type = 1;
        this.top = 96;
      } else {
        this.type = 2;
        this.top = 153;
      }
    },
    goPage() {
      // this.$refs.mainNav.scrollIntoView({
      //   behavior: "smooth",
      //   block: "top",
      // });
      var a = document.getElementById("mainNav").offsetTop;
      $("body,html").animate({ scrollTop: a - 200 }, 200);
      //公司新闻
      var form = {
        type: this.navIndex,
        pageSize: this.pageSize,
        pageNum: this.currentPage1,
      };
      getAcademic(form).then((response) => {
        this.companyNewsList = response.data.list;
        this.total = response.data.total;
      });
    },
    goHome() {
      this.$router.push({ name: "home" });
    },

    getRanking() {
      getacademicRanking().then((res) => {
        this.rankList = res.data;
      });
    },
    goDetail(obj) {
      if (obj.externalUrl && obj.externalUrl !== "") {
        window.open(obj.externalUrl, "_blank");
      } else {
        this.$router.push({
          name: "academicCenterDetail",
          params: { id: obj.id },
        });
      }
    },
    goDetailM(id) {
      this.$router.push({
        name: "newsDetail",
        params: { id: id },
      });
    },
    getAcademic() {
      this.currentPage1 = 1;
      this.companyNewsList = [];
      //公司新闻
      var typeJson = "";
      //   this.form.type.forEach((item,index)=>{
      //       if(index !== 0){
      //           typeJson += ","
      //       }
      //       typeJson += `'${item}'`
      //   })
      var form = {
        type: 4,
        pageSize: this.pageSize,
        pageNum: this.currentPage1,
        title: this.content,
        efficacyId: this.form.type.join(","),
      };
      getacademic(form).then((response) => {
        this.companyNewsList = response.data.list;
        this.total = response.data.total;
      });
    },
    getEffect() {
      geteffectList().then((res) => {
        console.log(res.data);
        if (res.data && res.data.length !== 0) {
          this.gxList = res.data;
        }
        this.getAcademic();
      });
    },
    getTypeName(id) {
      var name = "";
      this.gxList.forEach((item) => {
        if (item.id === id) {
          name = item.name;
        }
      });
      return name;
    },
    getUrl(val) {
      var name = val.replace("#", "");
      if (name === "enterprise") {
        this.navIndex = 1;
        this.type = 1;
        this.top = 96;
      } else {
        this.navIndex = 2;
        this.type = 2;
        this.top = 153;
      }
      this.getAcademic();
    },
    /**
     *@functionName:clearBtn
     *@params1: type(类型 || int)  1.功效 2.时间
     *@description:清空选项值
     *@author: 小舒
     *@date: 2023-08-21 11:13:57
     */
    clearBtn(type) {
      if (type === 1) {
        this.form.type = [];
      } else if (type === 2) {
        this.times = [];
      }

      this.getAcademic();
    },
    changeCheck() {
      this.getAcademic();
      console.log("change", this.form.type);
    },

    goLwDetail(obj) {
      if (obj.externalUrl && obj.externalUrl !== "") {
        window.open(obj.externalUrl, "_blank");
      } else {
        this.$router.push({
          name: "academicCenterDetail",
          query: { id: obj.id, type: 4 },
        });
      }
    },
  },

  destroyed() {
    window.removeEventListener("scroll", this.getScroll);
  },
};
</script>

<style lang="scss">
.lwRankingNav {
  margin-top: 24px;
  display: flex;
  line-height: 20px;
  align-items: center;
  .lwRankIndex {
    width: 30px;
    height: 30px;
    line-height: 30px;
    color: #fff;
    float: left;
    background: #d9d9d9;
    text-align: center;
    font-size: 14px;
    margin: 0 6px 0 0;
    font-style: italic;
  }
  .lwRanking {
    font-weight: 400;
    color: #5b5c60;
    line-height: 20px;
    -webkit-line-clamp: 2;
    flex: 1;
  }
  .lwRanking:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}
.academicCenter {
  .newsList {
    display: flex;
    align-items: center;
    margin-bottom: 67px;
    cursor: pointer;
    img {
      transition: all 0.5s;
    }
  }
  .selectLeft {
    background: #ffffff;
    box-shadow: 0px 2px 8px 0px #eef2f5;
    border-radius: 0px 0px 2px 2px;
    border-top: #86be1e 2px solid;
    padding: 0px 16px 10px 16px;
    box-sizing: border-box;
    width: 300px;
    margin-right: 60px;
    height: max-content;
  }
  .academicList {
    .academicList-top {
      background: #eef2f5;
      padding: 8px 10px;
      box-sizing: border-box;
      width: 100%;
      display: flex;
      align-items: center;
    }
    .academicList-main {
      width: 100%;
      padding: 20px 8px;
      box-sizing: border-box;
      border-bottom: #cccccc 1px dashed;
      display: flex;
      align-items: center;
      .academicList-Btn {
        a {
          display: none;
        }
      }
      .academicList-main-title {
        cursor: pointer;
      }
      .academicList-main-title:hover {
        text-decoration: underline;
      }
      .academicList-main-content {
        margin-top: 8px;
        padding: 2px 0;
        box-sizing: border-box;
        display: flex;
        font-size: 14px;
        color: #666;
      }
    }
    .academicList-main:hover {
      background-color: #f6f7f7;
      .academicList-Btn {
        a {
          width: auto;
          height: 32px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid #cccccc;
          font-size: 14px;
          font-weight: 400;
          color: #293a4c;
          line-height: 20px;
          padding: 0 15px;
          box-sizing: border-box;
          margin-right: 8px;
          display: flex;
          align-items: center;
          cursor: pointer;
        }
        a:hover {
          background-color: #3f6b33;
          color: #fff;
          border: 1px solid #3f6b33;
        }
      }
    }
    .academicList-main:last-child {
      margin-bottom: 10px;
    }
  }
  .newsList:hover {
    .title {
      color: #719468;
    }
    img {
      transform: scale(1.1);
    }
  }
  .maxWidth {
    width: 1229px;
    margin: 0 auto;
  }
  .mainIndex {
    width: 217px;
  }
  .mainContent {
    flex: 1;
  }
  #mainNav {
    position: relative;
    padding: 20px 72px 148px;
  }
  .brandProfileNav {
    position: relative;
  }
  .mainIndex {
    text-align: right;
    ul {
      padding: 8px 55px 8px 0;
    }
    .title {
      color: #1b1b1b;
      font-size: 27px;
      line-height: 27px;
      margin-bottom: 32px;
    }
    .index {
      color: #707070;
      font-size: 18px;
      line-height: 27px;
      margin-bottom: 30px;
    }
    .index:last-child {
      margin-bottom: 0;
    }
  }
  .clickBtn2 {
    cursor: pointer;
  }
  .selectBtn {
    color: #3f6b33;
    cursor: pointer;
    position: relative;
  }
  .selectBtn1::after {
    content: "";
    width: 100%;
    height: 2px;
    background: #3f6b33;
    position: absolute;
    bottom: -10px;
    left: 0;
    transition: all 0.5s ease 0s;
  }
  .clearBtn {
    font-weight: 400;
    color: #2878ff;
    line-height: 20px;
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/academicCenter/index.vue